import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from "react-router";
import { connect } from 'react-redux';
import { toggleSidebar  } from '../../store/actions';
import ProfileMenu from './Menus/profileMenu';
import logoLight from "../../images/switch-logo.svg";
import logoSmall from "../../images/switch-symbol.png";

class Topbar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            create_menu: false,
            istoggle : false
        };
        this.toggleCreate = this.toggleCreate.bind(this);
    }
    toggleCreate() {
        this.setState(prevState => ({
            create_menu: !prevState.create_menu
        }));
    }

    sidebarToggle = () =>{
        document.body.classList.toggle('enlarged');
        this.props.toggleSidebar(!this.props.is_toggle);
     }

    
    toggleFullscreen() {
        if (!document.fullscreenElement && /* alternative standard method */ !document.mozFullScreenElement && !document.webkitFullscreenElement) {  // current working methods
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
            }
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            }
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="topbar">
                    <div className="topbar-left">
                        <Link to="/dashboard" className="logo">
                            <span className="logo-light">
                                <img src={logoLight} alt="" height="30" />
                            </span>
                            <span className="logo-sm">
                                <img src={logoSmall} alt="" height="30" />
                            </span>
                        </Link>
                    </div>

                    <nav className="navbar-custom rbd-pc-hero-blue">
                        <ul className="navbar-right list-inline float-right mb-0">
                            <li className="dropdown notification-list list-inline-item d-none d-md-inline-block mr-1">
                                <form role="search" className="app-search">
                                    <div className="form-group mb-0">
                                        <input type="text" className="form-control" placeholder="Search.." />
                                        <button type="submit"><i className="fa fa-search"></i></button>
                                    </div>
                                </form>
                            </li>

                            <li className="dropdown notification-list list-inline-item d-none d-md-inline-block mr-1">
                                <Link onClick={this.toggleFullscreen} className="nav-link waves-effect" to="#" id="btn-fullscreen">
                                    <i className="ion ion-md-qr-scanner noti-icon"></i>
                                </Link>
                            </li>
                            <ProfileMenu />
                        </ul>

                        <ul className="list-inline menu-left mb-0">
                            <li className="float-left">
                                <button onClick={ this.sidebarToggle }   className="button-menu-mobile open-left waves-effect rbd-pc-hero-blue">
                                    <i className="mdi mdi-menu"></i>
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    const { is_toggle } = state.Layout;
    return {  is_toggle };
}

export default withRouter(connect(mapStatetoProps, { toggleSidebar })(Topbar));















